import { memo } from "react";
import { useTranslation } from "@/i18n/useTranslation";
import type { VisibleForm } from "./types";

interface ScoreTableHeaderProps {
  columnWidth: string;
  formColumns: VisibleForm[];
  language: string;
}

export const ScoreTableHeader = memo(({ columnWidth, formColumns, language }: ScoreTableHeaderProps) => {
  const { t } = useTranslation();

  return (
    <div
      className="sticky top-0 z-10 grid gap-4 rounded-xl bg-slate-100/90 text-foreground font-semibold shadow-2xs border border-slate-200/90 backdrop-blur-md mb-2 dark:bg-slate-800/90 dark:border-slate-700/80"
      style={{ gridTemplateColumns: `repeat(${formColumns.length + 2}, ${columnWidth})` }}
    >
      <div className="py-3 px-4 text-center text-xs font-semibold text-slate-700 dark:text-slate-300 sm:text-sm">
        {t("dashboard.table.script_column")}
      </div>
      <div className="py-3 px-4 text-center text-xs font-semibold text-slate-700 dark:text-slate-300 sm:text-sm">
        {t("dashboard.table.version_column")}
      </div>
      {formColumns.map((form) => (
        <div
          key={form.id}
          className="py-3 px-4 text-center text-xs font-semibold text-slate-700 dark:text-slate-300 sm:text-sm truncate"
        >
          {language === "th" && form.nameTh ? form.nameTh : form.name}
        </div>
      ))}
    </div>
  );
});

ScoreTableHeader.displayName = "ScoreTableHeader";
